module.exports = __webpack_public_path__ + "img/project-cover10.e609b71d.jpg";